import $http from '../../../../axios-instance';
import Swal from 'sweetalert2'

export async function getJsonSga({commit, state, rootState}) {

  var producto = rootState.productos_et.selectedProductEt.id;

  if (producto == "") {
    producto = rootState.productos_et.selectedProductEt.Idproducto;
  }
  await $http.get(`productos_et_sga/codigosh/${producto}`, state.ingreso)
    .then((response) => {
      
      commit('cargarJsonSga', response.data)
    })
    .catch((error) => {

    })

}

export async function guardarSga({commit, state, rootState, dispatch}) {

  commit('dashboard/load', true, {root: true})

  var producto = rootState.productos_et.selectedProductEt.id;
  var idioma = rootState.productos_et.selectedProductEt.idioma;

  if (producto == "") {
    producto = state.selectedProductEt.Idproducto;
  }

  await $http.post(`productos_et_sga/crear/${producto}`, {codigos: state.selectedSgaEt.codigos, idioma: idioma})
    .then((response) => {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: response.data.message,
        showConfirmButton: false,
        timer: 3000
      })
      //commit('setProduct', response.data.data)
      dispatch('getCategorias');
      state.error = false
    })
    .catch((error) => {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error.message + '<br> ' + error.errors,
        showConfirmButton: true,
        timer: 5000
      })
      reject(error);
      //commit('productError', error.message)
    })

  commit('dashboard/load', false, {root: true})
}

export async function getSga({commit, state, rootState}) {

  var producto = rootState.productos_et.selectedProductEt.id;
  if (producto == "") {
    producto = rootState.productos_et.selectedProductEt.Idproducto;
  }

  await $http.get(`productos_et_sga/sga/${producto}`)
    .then((response) => {
      commit('setSga', response.data)
    })
    .catch((error) => {

    })
}

/**
 * Método para obtener los pictogramas pertenecientes al producto químico segun su clasificación.
 *
 * @param {*} param0
 */
export async function getPictogramas({commit, state, rootState}) {

  var producto = rootState.productos_et.selectedProductEt.id;
  if (producto == "") {
    producto = state.selectedProductEt.Idproducto;
  }

  await $http.get(`productos_et_sga/pictogramas/${producto}`)
    .then((response) => {
      commit('setSgaPictogramas', response.data)
    
    })
    .catch((error) => {

    })
}


/**
 * Método para obtener las frases SGA del producto químico segun su clasificación.
 *
 * @param {*} param0
 */
export async function getFrases({commit, state, rootState}) {

  var producto = rootState.productos_et.selectedProductEt.id;
  if (producto == "") {
    producto = state.selectedProductEt.Idproducto;
  }

  var idioma = rootState.productos_et.selectedProductEt.idioma;
  // TODO: cambiar version cuando sea dinamico
  var version = 6;
  var empresa = rootState.productos_et.selectedProductEt.id_empresa;

  var tipo = rootState.sga_et.tipo;

  if (empresa === "") {
    empresa = 0;
  }

  // $api->get('productos_et_sga/sga/frases/{id}/{idioma}/{version}/{empresa}/{tipo}', 'App\Http\Controllers\ApiCore\ProductosEt\SistemasClasificacion\ProdEtFrasesController@getFrases');

  await $http.get(`productos_et_sga/sga/frases/${producto}/${idioma}/${version}/${empresa}/${tipo}`)
    .then((response) => {
      commit('setSgaFrases', response.data.data)
    })
    .catch((error) => {

    })
}

/**
 * Método para cambiar el estado del pictograma del producto químico.
 *
 * @param {*} param0
 * @param {*} pictograma contiene la información de los pictogramas.
 */
export async function cambiaEstado({commit, state, rootState, dispatch}, pictograma) {
  commit('dashboard/load', true, {root: true})

  var producto = rootState.productos_et.selectedProductEt.id;
  if (producto == "") {
    producto = state.selectedProductEt.Idproducto;
  }

  

  if (rootState.productos_et.selectedProductEt.finalizado == 1) {
    
    Swal.fire({
      position: 'center',
      icon: 'error',
      title: 'No tiene habilitada la edicion de este producto',
      showConfirmButton: false,
      timer: 2000
    })
  } else {
    

    if (pictograma.estado == 1) {
      pictograma.estado = 0;
    } else {
      pictograma.estado = 1;
    }

    await $http.post(`productos_et_sga/pictogramas/${producto}`, pictograma)
      .then((response) => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        })
        dispatch('getPictogramas');

        state.error = false
      })
      .catch((error) => {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error.message,
          showConfirmButton: false,
          timer: 2000
        })
      })
  }

  commit('dashboard/load', false, {root: true})
}

/**
 * Método para reinicar las frases SGA del producto químico.
 *
 * @param {*} param0
 */
export async function reiniciarFrases({commit, state, rootState, dispatch}) {
  commit('dashboard/load', true, {root: true})

  var producto = rootState.productos_et.selectedProductEt.id;
  if (producto == "") {
    producto = state.selectedProductEt.Idproducto;
  }

  var empresa = rootState.productos_et.selectedProductEt.id_empresa;
  var idioma = rootState.productos_et.selectedProductEt.idioma;

  if (empresa === "") {
    empresa = 0;
  }

  var datos = {
    id_empresa: empresa,
    idioma: idioma,
    version: 6
  };
  // productos_et_sga/{id}/frases/del
  await $http.delete(`productos_et_sga/${producto}/frases/del`, datos)
    .then(async (response) => {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: response.data.message,
        showConfirmButton: false,
        timer: 2000
      })
      await dispatch('getFrases');
      state.error = false
    })
    .catch((error) => {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: response.data.message,
        showConfirmButton: false,
        timer: 2000
      })
    })
  commit('dashboard/load', false, {root: true})
}

/**
 * Método para guardar las frases SGA del producto químico.
 *
 * @param {*} param0
 */
export async function guardarFrases({commit, state, rootState, dispatch}) {

  commit('dashboard/load', true, {root: true})

  var producto = rootState.productos_et.selectedProductEt.id;
  if (producto == "") {
    producto = state.selectedProductEt.Idproducto;
  }

  var empresa = rootState.productos_et.filtroEt.empresa;

  if (empresa == "") {
    empresa = 0;
  }

 

  rootState.sga_et.FrasesEt.medidas[0][0] = rootState.sga_et.Medidas.medidah4x6;
  rootState.sga_et.FrasesEt.medidas[0][1] = rootState.sga_et.Medidas.medidap4x6;
  rootState.sga_et.FrasesEt.medidas[1][0] = rootState.sga_et.Medidas.medidah7x10;
  rootState.sga_et.FrasesEt.medidas[1][1] = rootState.sga_et.Medidas.medidap7x10;
  rootState.sga_et.FrasesEt.medidas[2][0] = rootState.sga_et.Medidas.medidah18x10;
  rootState.sga_et.FrasesEt.medidas[2][1] = rootState.sga_et.Medidas.medidap18x10;
  rootState.sga_et.FrasesEt.medidas[3][0] = rootState.sga_et.Medidas.medidah21x18;
  rootState.sga_et.FrasesEt.medidas[3][1] = rootState.sga_et.Medidas.medidap21x18;

  var datos = {
    id_empresa: empresa,
    frasesh: rootState.sga_et.FrasesEt.frasesh,
    frasesp: rootState.sga_et.FrasesEt.frasesp,
    edicion: rootState.sga_et.FrasesEt.edicion,
    idioma: rootState.productos_et.selectedProductEt.idioma,
    version: rootState.sga_et.FrasesEt.version,
    medidas: rootState.sga_et.FrasesEt.medidas,
    tipo: rootState.sga_et.tipo,
    id_producto: producto
  };

  await $http.put(`productos_et_sga/sga/frases/editar/${producto}`, datos)
    .then((response) => {
    
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: response.data.msg,
        showConfirmButton: false,
        timer: 3000
      })

      //dispatch('getFrases');
      state.error = false
    })
    .catch((error) => {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error.message + '<br> ' + error.errors,
        showConfirmButton: true,
        timer: 5000
      })
      reject(error);
    })

  commit('dashboard/load', false, {root: true})
}

export async function resetEmpresa({commit, state}) {
  
  commit('resetFiltro');
}

export async function getCategorias({commit, state, rootState, dispatch}) {


  var producto = rootState.productos_et.selectedProductEt.id;
  if (producto == "") {
    producto = state.selectedProductEt.Idproducto;
  }

  var empresa = rootState.productos_et.selectedProductEt.id_empresa;
  var idioma = rootState.productos_et.selectedProductEt.idioma;
  // TODO: cambiar version cuando sea dinamico
  var version = 6;

  //{id}/{idioma}/{version}/{empresa}

  await $http.get(`productos_et_sga/categorias/${producto}/${idioma}/${version}/${empresa}`)
    .then((response) => {
      commit('setCategorias', response.data);
    })
    .catch((error) => {

    })
}

//productos_et_sga/categorias/{id_producto}/{id_categoria}/{id_empresa}

export async function eliminarCategoria({commit, state, rootState, dispatch}, id_categoria) {


  var producto = rootState.productos_et.selectedProductEt.id;
  if (producto == "") {
    producto = state.selectedProductEt.Idproducto;
  }

  var empresa = rootState.productos_et.selectedProductEt.id_empresa;

  await $http.delete(`productos_et_sga/categorias/${producto}/${id_categoria}/${empresa}`)
    .then((response) => {
      // TODO: Faltaria reiniciar las frases
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: response.data.message,
        showConfirmButton: false,
        timer: 3000
      })
      dispatch('getCategorias');
    })
    .catch((error) => {

    })
}
